import script from "./AdministradorUsuariosView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministradorUsuariosView.vue?vue&type=script&setup=true&lang=js"

import "./AdministradorUsuariosView.vue?vue&type=style&index=0&id=2a75ebb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a75ebb5"]])

export default __exports__